export default {
  computed: {
    currentList() {
      if (!this.$store.state.user.profile.currentList) {
        return {};
      }
      return this.$store.state.user.profile.currentList;
    },
    currentListPercentage() {
      if (this.$store.getters.getProfile && this.$store.getters.getProfile.currentList) {
        return this.$store.getters.getProfile.currentList.percentage / 100;
      }
      return 0;
    },
    currentType() {
      return this.$store.getters.getProfile.type;
    },
  },
  methods: {
    hasRole(roleName) {
      if (!this.$store.getters.getProfile.roles) {
        return false;
      }
      const found = this.$store.getters.getProfile.roles.filter((e) => {
        return roleName === e.name;
      });
      return found.length > 0;
    },
  }
}